export default __webpack_public_path__ + "static/media/15f35c98c694592e1097102395c0cc761575922132890.dbd9f96f.webp";